
<h1 mat-dialog-title>Error</h1>
<div mat-dialog-content>
    <p>{{ data.message }}</p>
  
</div>
<div mat-dialog-actions style="margin-top: 9px !important; float: right !important;">
  <button mat-raised-button
  (click)="onClose()">Close  
  </button>
  
</div>
